import { CompositeCondition } from './composite-conditions.model';
import { BaseModel } from '../../interfaces/base-model';
import { CrmEntity } from '../../crm-entities/crm-entities.model';
import { TranslateService } from '@ngx-translate/core';

export abstract class BaseCondition extends BaseModel {
  public parent: CompositeCondition = null;

  constructor(modelType: string) {
    super(modelType);
  }

  /**
   * @returns the depth in which this is condition is in (how far it is from the root)
   */
  getDepth(): number {
    let currentDepth = 0;
    let currentCondition: BaseCondition = this;
    while (true) {
      if (currentCondition.parent) {
        currentDepth++;
        currentCondition = currentCondition.parent;
      } else {
        break; // this is adam and eave :-)  (the root)
      }
    }

    return currentDepth;
  }

  /**
   * returns a string representation of the condition (could be also a rendering to a specific output. like the free marker representation)
   */
  abstract generateExpression(): string;

  abstract getHeight(): number;

  abstract clone(): BaseCondition;

  abstract generateHtmlForPreview(entities: CrmEntity[], translate: TranslateService): string;

  abstract checkValidity(entities: CrmEntity[]): boolean;
}
